import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../App.css';
import CountUp from "react-countup";

const collectionsData = [
  { title: 'Databases', value: process.env.REACT_APP_DATABASES },
  { title: 'Print Titles', value: process.env.REACT_APP_PRINT_TITLES },
  { title: 'Electronic Titles', value: process.env.REACT_APP_ELECTRONIC_TITLES },
  { title: 'Physical Media', value: process.env.REACT_APP_PHYSICAL_MEDIA },
  { title: 'Electronic Media', value: process.env.REACT_APP_ELECTRONIC_MEDIA },
  { title: 'Journals', value: process.env.REACT_APP_JOURNALS },
  // { title: 'New Books Added', value: process.env.REACT_APP_NEW_BOOKS_ADDED },
];

const usageData = [
  { title: 'Total Checkouts', value: process.env.REACT_APP_TOTAL_CHECKOUTS },
  { title: 'Total Ebook and Emedia Checkouts', value: process.env.REACT_APP_EBOOKS_AND_EMEDIA_USAGE },
  { title: 'Ejournal Checkouts', value: process.env.REACT_APP_EJOURNAL_CHECKOUTS },
];

const CollectionsPage = () => {
  return (
    <div>
      <Container className="mt-5">
        {/* <Row className="usage-section p-4 rounded mb-5">
          <Col>
            <h6 className="text-center usage-subtitle"> Academic Year: {process.env.REACT_APP_ACADEMIC_YEAR }</h6>
          </Col>
        </Row> */}

        <Row>
          {collectionsData.map((item, index) => (
            <Col md={4} className="mb-4" key={index}>
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">{item.title}</Card.Title>
                  <Card.Text className="collection-value">{item.value}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <Row className="usage-section p-4 rounded mb-5">
          <Col>
            <h4 className="text-center usage-title">Usage</h4>
          </Col>
        </Row>

        <Row>
          {usageData.map((item, index) => (
            <Col md={4} className="mb-4" key={index}>
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">{item.title}</Card.Title>
                  <Card.Text className="collection-value">
                    <CountUp end={item.value} duration={2} separator="," />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CollectionsPage;
